import React from "react";

const DebitosAcaoCobrancaCard = ({ debitosAcaoFiscalCobranca }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>Débitos Ação Fiscal Cobrança</b>
      </div>
      <div className="card-body">
        {" "}
        <center>
          <table className="table table-striped table-bordered" width="80%">
            <thead>
              <tr>
                <th>
                  <center>Origem</center>
                </th>
                <th>
                  <center>Valor Nominal (R$)</center>
                </th>
              </tr>
            </thead>
            <tbody>
              {debitosAcaoFiscalCobranca?.debitos?.map((debito) => (
                <tr>
                  <td>
                    <center>{debito.Origem}</center>
                  </td>
                  <td align="right">{debito.valor.toLocaleString("pt-br", { minimumFractionDigits: 2 })}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </center>
      </div>
    </div>
  </div>
);

export default DebitosAcaoCobrancaCard;
